import React, { memo } from "react";

import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getPropertiesByBusinessId, getPropertyById } from "selectors";

import { Property } from "./Property";

export const DeploymentProperty = memo(props => {
  const { businessId, propertyId } = props;

  const property = useSelector(getPropertyById(propertyId)) || {};

  const properties = useSelector(getPropertiesByBusinessId(businessId));
  const names = properties
    .filter(
      localProperty => localProperty.name && localProperty.id === propertyId,
    )
    .map(localProperty => localProperty.name);
  if (property.name) {
    names.push(property.name);
  }

  return <Property pic={property.PIC} names={names} />;
});
DeploymentProperty.propTypes = {
  businessId: PropTypes.string.isRequired,
  propertyId: PropTypes.string.isRequired,
};
